import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { nextStep } from '../../../features/application/reducers/next-step';
import { RootState } from '../../../store';

const selector = ({ nextStep: { initialized } }: RootState) => ({
  initialized,
});

type Props = { redirect?: boolean; children: React.ReactNode };

const StepRoute: React.FC<Props> = ({ redirect = false, children }: Props) => {
  const { initialized } = useSelector(selector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!initialized) {
      dispatch(
        nextStep({
          gotoNextPage: redirect,
        }),
      );
    }
  }, [dispatch, initialized, redirect]);

  return initialized ? <>{children}</> : <></>;
};

export { StepRoute };
